export const CATEGORY_CONFIG = [
  { key: "lead", label: "New leads", color: "success", icon: "target" },
  { key: "complaint", label: "Complaints", color: "danger", icon: "alert" },
  { key: "query", label: "Queries", color: "info", icon: "help" },
  { key: "noise", label: "Noise", color: "secondary", icon: "filter" },
];

export const CATEGORY_BADGE_CLASS = {
  lead: "bg-success-subtle text-success",
  complaint: "bg-danger-subtle text-danger",
  query: "bg-info-subtle text-info",
  noise: "bg-secondary-subtle text-secondary",
};

export const STATUS_BADGE_CLASS = {
  completed: "bg-success-subtle text-success",
  failed: "bg-danger-subtle text-danger",
  pending: "bg-warning-subtle text-warning",
};

export const AVATAR_COLORS = ["success", "warning", "primary", "info", "danger"];

export const formatRelativeTime = (date) => {
  if (!date) return "—";
  const diffMs = Date.now() - new Date(date).getTime();
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ${minutes % 60}m ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};

export const formatDurationLabel = (durationMs) => {
  if (!durationMs || durationMs < 0) return "—";
  const minutes = Math.round(durationMs / 60000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ${minutes % 60}m`;
};